import { ScreenAttributes } from 'core/flow/entities';
import { useFlowBackgroundVideo } from 'core/flow/hooks';
import { LoopingVideo } from './LoopingVideo';
import { ContainerStyled } from './styled';

type FlowVideoBackgroundProps = {
  screenAttributes: ScreenAttributes;
};

const getHasBackgroundVideo = (screenAttributes: ScreenAttributes) => {
  return 'hasBackgroundVideo' in screenAttributes && !!screenAttributes.hasBackgroundVideo;
};

export const FlowVideoBackground = ({ screenAttributes }: FlowVideoBackgroundProps) => {
  const backgroundVideo = useFlowBackgroundVideo();

  if (!backgroundVideo) {
    return null;
  }

  const isVisible = getHasBackgroundVideo(screenAttributes);

  return (
    <ContainerStyled $isHidden={!isVisible}>
      <LoopingVideo {...backgroundVideo} isPaused={!isVisible} />
    </ContainerStyled>
  );
};
